// Кодування windows-1251 без залежностей (у браузері й на сервері): таблицю будуємо з TextDecoder.
// encode повертає { bytes, bad } — bad: символи, яких у windows-1251 немає (їх не можна подати в ДПС).
let table = null;
function map() {
  if (table) return table;
  table = new Map();
  const dec = new TextDecoder("windows-1251");
  for (let b = 0; b < 256; b++) {
    const ch = dec.decode(new Uint8Array([b]));
    if (ch !== "�" && !table.has(ch)) table.set(ch, b);
  }
  return table;
}

export function encodeCp1251(text) {
  const t = map(), out = new Uint8Array(text.length), bad = new Set();
  let i = 0;
  for (const ch of text) {
    const b = t.get(ch);
    if (b === undefined) { bad.add(ch); out[i++] = 0x3f; } else out[i++] = b;
  }
  return { bytes: out.subarray(0, i), bad: [...bad] };
}

export const decodeCp1251 = (bytes) => new TextDecoder("windows-1251").decode(bytes);
